/* eslint-disable react-hooks/exhaustive-deps */
import { Hidden } from '@mui/material';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useAuth } from '../../providers/AuthProvider';
import { Footer } from './Footer';
import { Header } from './Header';
import { MenuMobile } from './MenuMobile';
import { SplashScreen } from './SplashScreen';

const LayoutLoggedAreaContainer = styled.div`
  main {
    min-height: calc(100vh - 341px); //80 header + 256 footer + grid margins
  }
`;

export const LayoutLoggedArea = (props) => {
  const { authVerification, NAVIAGATE_DELAY } = useAuth();
  const [ loadingPage, setLoadingPage ] = useState(true);

  useEffect(() => {
    let mounted = true;
    if ( mounted ) {
      authVerification();
      
      setTimeout(() => {
        setLoadingPage(false);
      }, NAVIAGATE_DELAY);
    }
  
    return () => mounted = false;
  }, [])
  
  return (
    <LayoutLoggedAreaContainer>
      { loadingPage ? (
        <SplashScreen />
      ) : (
        <>
          <Header />
          <main>
            {props.children}
          </main>
          <Footer />
          <Hidden smUp>
            <MenuMobile />
          </Hidden>
        </>
      )}
    </LayoutLoggedAreaContainer>
  )
}
